import {
  APP_CONSTANT_INVALID_EMAIL,
  APP_CONSTANT_INVALID_PASSWORD,
  APP_CONSTANT_INVALID_NAME,
  APP_CONSTANT_PASSWORD_NOT_MATCH,
  APP_CONSTANT_INVALID_CREDENTIALS,
} from "./constants";
export const checkValidate = (email, password) => {
  const isEmailValid = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+\.[a-zA-z]{2,3}$/.test(
    email
  );
  const isPasswordValid =
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(password);

  if (!isEmailValid) {
    return APP_CONSTANT_INVALID_CREDENTIALS;
  }
  if (!isPasswordValid) {
    return APP_CONSTANT_INVALID_CREDENTIALS;
  }
  return null;
};

export const signUpValidate = (payload) => {
  const { email, name, password } = payload;
  const isEmailValid = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+\.[a-zA-z]{2,3}$/.test(
    email
  );
  const isPasswordValid =
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(password);
  if (!name) {
    return APP_CONSTANT_INVALID_NAME;
  }
  if (!isEmailValid) {
    return APP_CONSTANT_INVALID_EMAIL;
  }
  if (!isPasswordValid) {
    return APP_CONSTANT_INVALID_PASSWORD;
  }
};

export const passwordResetValidate = (payload) => {
  const { email } = payload;
  const isEmailValid = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+\.[a-zA-z]{2,3}$/.test(
    email
  );
  if (!isEmailValid) {
    return APP_CONSTANT_INVALID_EMAIL;
  }
};

export const passwordConfirmationValidate = (payload) => {
  let { password, confirmPassword } = payload;
  password = password?.trim();
  confirmPassword = confirmPassword?.trim();

  if (password !== confirmPassword) {
    return APP_CONSTANT_PASSWORD_NOT_MATCH;
  }

  const isPasswordValid =
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(password);

  const isConfirmPasswordValid =
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(password);

  if (!isPasswordValid) {
    return APP_CONSTANT_INVALID_PASSWORD;
  }

  if (!isConfirmPasswordValid) {
    return APP_CONSTANT_INVALID_PASSWORD;
  }
};
